module.exports = __webpack_public_path__ + "img/ff-b.bc82cf37.png";